import { render, staticRenderFns } from "./ArticleBlock.vue?vue&type=template&id=7fe7d05a&scoped=true&"
import script from "./ArticleBlock.vue?vue&type=script&lang=ts&"
export * from "./ArticleBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleBlock.vue?vue&type=style&index=0&id=7fe7d05a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe7d05a",
  null
  
)

export default component.exports